import {Component, OnInit} from '@angular/core';
import {ReferInfoResponse} from "../../core/referrals/refer-info-response";
import {Environment} from "../../core/environment-core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";
import {MessageResponse} from "../../core/banner/message-response";
import {BannerService} from "../../core/banner/banner.service";
import {ActivationMessageModalComponent} from "./modal/activation-message-modal-component";
import {MessageService} from "primeng/components/common/messageservice";

@Component({
  selector: 'app-banners',
  templateUrl: './banners.component.html',
  styleUrls: ['./banners.component.scss']
})
export class BannersComponent implements OnInit {

  messages: MessageResponse[] = [];
  loading = false;

  constructor(public environment: Environment,
              private modalService: NgbModal,
              private router: Router,
              private bannerService: BannerService,
              private messageService: MessageService) {
    this.getMessages();
  }

  ngOnInit() {
  }

  changeStatus(message) {
    const modalRef = this.modalService.open(ActivationMessageModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.action = 'activate';
    modalRef.result.then((result) => {
      console.log(result);
    }, (reason) => {
      console.log(reason);
    });
  }

  deleteMessage(message) {
    const modalRef = this.modalService.open(ActivationMessageModalComponent, {backdrop: 'static'});
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.action = 'delete';
    modalRef.result.then((result) => {
      console.log(result);
      this.messageService.clear();
      this.messageService.add({
        severity: 'success',
        summary: '',
        detail: 'Se elimino mensaje correctamente'
      });
      this.messages = [];
      this.getMessages();
    }, (reason) => {
      console.log(reason);
    });
  }
  getMessages() {
    this.loading = true;
    this.bannerService.getMessagesOfBanner().subscribe(
      (response) => {
        this.messages = response;
        console.log(this.messages);
        this.loading = false;
      },
      (error) => {
        console.log('getMessages:error');
        console.log(error);
        this.loading = false;
      }
    );
  }

  parseDateToString(dateAsLong): string {
    const date = new Date(+dateAsLong);
    return date.getFullYear() + '-' + this.formatDate(date.getMonth() + 1) + '-' + this.formatDate(date.getDate());
  }

  formatDate(monthOrDay): any {
    return [(monthOrDay > 9 ? '' : '0') + monthOrDay].join('');
  }



  goToReferral(referralKey: string) {
    this.router.navigate(['/ganalottodo/refer/' + referralKey]);
  }

  addMessage() {
    this.router.navigate(['/ganalottodo/banner/message/new']);
  }

  updateMessage(messageKey) {
    this.router.navigate(['/ganalottodo/banner/message/' + messageKey]);
  }


}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/banners/banners.component.ts